// removed by extract-text-webpack-plugin
module.exports = {"deliveryStatusContent":"G482e5a"};